import i18n from '@/langs'
import forEach from 'lodash-es/forEach'
import get from 'lodash-es/get'

// Начальное состояние
const state = {
	theme: null,
	popups: {
		requestForm: false,
		policyPopup: false,
	},
	requestFormErrors: {},
}

// Синхронные изменения состояний
const mutations = {
	TOGGLE_POPUP(state, { name, show }) {
		state.popups[name] = !!show
	},

	SET_REQUEST_FORM_ERRORS(state, { errors, field, fieldErrors }) {
		if (field) {
			if (fieldErrors) Vue.set(state.requestFormErrors, field, fieldErrors)
			else Vue.delete(state.requestFormErrors, field)
		} else if (errors) state.requestFormErrors = errors
		else state.requestFormErrors = {}
	},
}

// Геттеры
const getters = {
	isThemeDark(state) {
		return state.theme == 'dark'
	},
}

// Асинхронные изменения
const actions = {
	togglePopup({ commit }, { name, show }) {
		if (name == 'requestForm') {
			document.getElementById('footer-request-form').scrollIntoView({
				behavior: 'smooth',
			})
		} else commit('TOGGLE_POPUP', { name, show })
	},

	setRequestFormErrors({ commit }, { errors, field, fieldErrors }) {
		commit('SET_REQUEST_FORM_ERRORS', { errors, field, fieldErrors })
	},

	sendRequestForm({ commit }, data) {
		commit('SET_REQUEST_FORM_ERRORS', {})
		let formData = new FormData()
		forEach(data, (val, key) => {
			if (key === 'files')
				forEach(val, (file) => formData.append('files[]', file))
			else formData.append(key, val)
		})
		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url: '/order.php',
				data: formData,
			})
				.then((r) => r.data)
				.then((response) => {
					resolve(response)
				})
				.catch((errors) => {
					let fieldErrors = get(errors, 'errors.response.data.errors')
					if (fieldErrors)
						commit('SET_REQUEST_FORM_ERRORS', { errors: fieldErrors })
					else
						commit('SET_REQUEST_FORM_ERRORS', {
							field: 'main',
							fieldErrors: ['Что-то пошло не так...'],
						})
					reject(errors)
				})
		})
	},

	setUserLocale({}, locale) {
		i18n.locale = locale
		localStorage.setItem('userLocale', locale)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
